import React from 'react';
import { useSelector } from 'react-redux';

import ratnaImage from '../../../../images/discovery/ratna.svg';
import RatnaBullet from '../../../Icons/icons/RatnaBullet';
import SupportQuestion from '../../../Icons/icons/SupportQuestion';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';

import '../_modalComponent.scss';

import RatnaRenewalDate from './RatnaRenewalDate';

interface RatnaDescriptionProps {
  setLeftSection: (section: string) => void;
}

interface UserDetails {
  subscriptionStatus?: string;
}

interface OptionItemProps {
  title: string;
  subTitle: string;
  id?: number;
}

const ratnaDescriptionV1Users: OptionItemProps[] = [
  {
    title: '1 Ratna = 1 Creator saved to your list',
    subTitle:
      'Save creators to your lists with detailed metrics and contact info, including email. You can also use it to reveal +100 more creators.',
    id: 1,
  },
  {
    title: 'Why is it priced like this?',
    subTitle:
      'We get this data from social media APIs, it costs us more when you save more. There are no limits on how many you can manage after saving.',
    id: 2,
  },
  {
    title: 'Take back your time with Ratna',
    subTitle: 'No more spending hours every week finding creators manually. We allow you to search creators in bulk.',
    id: 3,
  },
];
const ratnaDescriptionV2Users: OptionItemProps[] = [
  {
    title: '1 Ratna = 1 Creator saved to your list',
    subTitle: 'Save creators to your lists with detailed metrics and contact info, including  email.',
    id: 1,
  },
  {
    title: 'Do Ratnas carry over?',
    subTitle:
      'Ratnas are use it or lose it. Your credits reset back to what your plan allows for every month. This is so you actually reach out to influencers each month!',
    id: 2,
  },
  {
    title: 'What if I want more?',
    subTitle: 'You can request for more Ratnas by upgrading your plan or buying a booster pack.',
    id: 3,
  },
];

const RatnaDescription: React.FC<RatnaDescriptionProps> = ({ setLeftSection }) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const isV2User = userDetails?.accountVersion === 'v2' ? true : false;

  const isTrialUser = (userDetails as UserDetails)?.subscriptionStatus === 'trial';

  const ratnaDescription = isV2User ? ratnaDescriptionV2Users : ratnaDescriptionV1Users;

  return (
    <>
      <h2 className="buy-ratna-modal-description-heading">
        <img width="28px" height="28px" src={ratnaImage} alt="celebration" />
        <span>What are Ratnas?</span>
      </h2>
      <p className="buy-ratna-modal-description-subheading">
        Ratna means a <span>“Special Gem”</span> Pronounced “rut-na”.
      </p>
      {isV2User && (
        <div className="buy-ratna-modal-description-subheading text-center font-poppins mt-2">
          They represent how many influencers you can save monthly using SARAL&apos;s search or chrome extension.
        </div>
      )}
      <div className="ratna-remaining-container-wrapper">
        <div className="ratna-remaining-container">
          Current Balance <img src={ratnaImage} width={20} height={20} alt="ratna" />
          <span style={{ fontWeight: 500 }}>{userDetails?.balance}</span>
        </div>
        <RatnaRenewalDate />
      </div>
      <div className="ratna-left-description-container">
        <div className="ratna-description-container">
          <OptionItem
            title={`You get ${userDetails?.plan?.ratnaCount || 300}  Ratna each month`}
            subTitle={`On your current plan, you get ${userDetails?.plan?.ratnaCount || 300} each month. You can get a tailor-made plan to  get more. ${
              isTrialUser ? 'You are currently on the free trial, so you will get 50 to test.' : ''
            }`}
          />
          {ratnaDescription.map(({ id, title, subTitle }) => (
            <OptionItem title={title} subTitle={subTitle} key={id} />
          ))}
        </div>
        <div className="modal-footer-button-container small-button-container ratna-description-buttons-container">
          <ButtonComponent
            variant="secondary"
            className="learn-more-button"
            onClick={() => {
              window.open(
                'https://getsaral.notion.site/What-is-Ratna-and-why-am-I-charged-extra-to-save-influencers-9da8359e94da4750bf36fdd9fce4b020'
              );
            }}>
            <SupportQuestion color="currentColor" />
            Learn More
          </ButtonComponent>
          <ButtonComponent
            variant="secondary-dark"
            className="one-time-ratna-button"
            onClick={() => setLeftSection('buy-ratna')}>
            <img width="20px" height="20px" src={ratnaImage} alt="celebration" style={{ marginBottom: '-3px' }} />
            One-time Ratna Boost
          </ButtonComponent>
        </div>
      </div>
    </>
  );
};

const OptionItem: React.FC<OptionItemProps> = ({ title, subTitle }) => {
  return (
    <div className="ratna-description-option">
      <div className="bullet-container">
        <RatnaBullet />
      </div>
      <div className="description-text-container">
        <div className="description-text-title">{title}</div>
        <div className="description-text-sub-title">{subTitle}</div>
      </div>
    </div>
  );
};

export default RatnaDescription;
